(() => {
  // Versuche mehrere mögliche Parameternamen (Shopify / DE / EN)
  const SIZE_PARAM_KEYS = [
    "filter.v.option.größe",
    "filter.v.option.Größe",
    "filter.v.option.grösse",
    "filter.v.option.Grösse",
    "filter.v.option.size",
    "filter.v.option.Size",
  ];

  function getSelectedSizes() {
    const params = new URLSearchParams(window.location.search);
    for (const key of SIZE_PARAM_KEYS) {
      const values = params.getAll(key);
      if (values && values.length) return values;
    }
    return [];
  }

  function applyFilter() {
    const selected = getSelectedSizes();
    if (!selected.length) {
      // Keine Größenfilter aktiv -> alles wieder zeigen
      document.querySelectorAll("[data-product-card]").forEach((card) => {
        card.style.display = "";
      });
      return;
    }

    const wanted = new Set(selected);

    document.querySelectorAll("[data-product-card]").forEach((card) => {
      const idxRaw = card.getAttribute("data-size-option-index");
      if (idxRaw === "" || idxRaw === null) return; // Produkt ohne Größenoption -> nicht anfassen

      const idx = Number(idxRaw);
      if (!Number.isFinite(idx)) return;

      let variants;
      try {
        variants = JSON.parse(card.getAttribute("data-variants"));
      } catch {
        return;
      }

      const ok = variants.some((v) => {
        const opts = Array.isArray(v.options) ? v.options : [];
        const sizeValue = opts[idx];
        return sizeValue && wanted.has(sizeValue) && v.available === true;
      });

      card.style.display = ok ? "" : "none";
    });
  }

  // 1) Initial
  // Theme kann nachladen -> daher minimal verzögert + beim DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      applyFilter();
      setTimeout(applyFilter, 200);
    });
  } else {
    applyFilter();
    setTimeout(applyFilter, 200);
  }

  // 2) Re-apply bei URL-Änderungen ohne Reload (Filter-Ajax)
  const _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    applyFilter();
  };

  const _replaceState = history.replaceState;
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    applyFilter();
  };

  window.addEventListener("popstate", applyFilter);

  // 3) Re-apply wenn das Grid per Ajax neu gerendert wird
  const obs = new MutationObserver(() => {
    // throttle light
    clearTimeout(window.__sizeAvailT);
    window.__sizeAvailT = setTimeout(applyFilter, 50);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
